export const THEME_TYPE = {
  SET_MODE_THEME: 'SET_MODE_THEME',
  CHANGE_PALETTE: 'CHANGE_PALETTE',
  GET_LOCAL_PALETTE: 'GET_LOCAL_PALETTE',
};
